import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { AccesoIpService } from 'src/app/services/seguridad/acceso-ip.service';

interface IpEntry {
  direcionIp: string;
  fechaAcceso?: string;
}

interface Sucursal {
  COD_SURC: number;
  DIR_SURC: string;
  ips: IpEntry[];
}

@Component({
    selector: 'app-acceso-ip',
    templateUrl: './acceso-ip.component.html',
    styleUrls: ['./acceso-ip.component.scss'],
    standalone: false
})
export class AccesoIpComponent implements OnInit {

  sucursales: Sucursal[] = [];
  selected: Sucursal | null = null;
  nuevaIp = '';
  cargando = false;
  guardando = false;

  constructor(
    private accesoIpService: AccesoIpService,
    private toastr: ToastrService
  ) {}

  get token(): string {
    return localStorage.getItem('token') || '';
  }

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.cargando = true;
    this.accesoIpService.listarSucursales(this.token).subscribe((resp: any) => {
      this.cargando = false;
      this.sucursales = Array.isArray(resp?.rows) ? resp.rows : [];
      if (this.sucursales.length > 0 && !this.selected) {
        this.selected = this.sucursales[0];
      }
    });
  }

  seleccionar(s: Sucursal): void {
    this.selected = s;
    this.nuevaIp = '';
  }

  agregar(): void {
    const ip = this.nuevaIp.trim();
    if (!ip) return;

    if (!this.validarIp(ip)) {
      this.toastr.warning('Ingresa una IP válida (ej: 192.168.1.100)', 'Atención', { timeOut: 3000 });
      return;
    }

    if (!this.selected) return;

    if (this.selected.ips.some(e => e.direcionIp === ip)) {
      this.toastr.warning('Esa IP ya está registrada en esta sucursal.', 'Atención', { timeOut: 3000 });
      return;
    }

    this.guardando = true;
    this.accesoIpService.agregarIp(this.token, this.selected.COD_SURC, ip).subscribe({
      next: (resp: any) => {
        this.guardando = false;
        this.selected!.ips = resp?.ips || [];
        this.syncSucursal(this.selected!);
        this.nuevaIp = '';
        this.toastr.success(`IP ${ip} agregada correctamente.`, 'Listo', { timeOut: 2500 });
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo agregar la IP.', 'Error', { timeOut: 3500 });
      }
    });
  }

  async eliminar(ip: IpEntry): Promise<void> {
    if (!this.selected) return;

    const result = await Swal.fire({
      icon: 'warning',
      title: '¿Eliminar IP?',
      text: `Se eliminará ${ip.direcionIp} de ${this.selected.DIR_SURC}.`,
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) return;

    this.guardando = true;
    this.accesoIpService.eliminarIp(this.token, this.selected.COD_SURC, ip.direcionIp).subscribe({
      next: (resp: any) => {
        this.guardando = false;
        this.selected!.ips = resp?.ips || [];
        this.syncSucursal(this.selected!);
        this.toastr.success(`IP ${ip.direcionIp} eliminada.`, 'Listo', { timeOut: 2500 });
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo eliminar la IP.', 'Error', { timeOut: 3500 });
      }
    });
  }

  fixIpInput(event: Event): void {
    const el = event.target as HTMLInputElement;
    const clean = el.value.replace(/,/g, '.');
    if (clean !== el.value) {
      el.value = clean;
      this.nuevaIp = clean;
    }
  }

  onEnter(event: Event): void {
    event.preventDefault();
    this.agregar();
  }

  private validarIp(ip: string): boolean {
    const re = /^(\d{1,3}\.){3}\d{1,3}$/;
    return re.test(ip) && ip.split('.').every(n => parseInt(n, 10) <= 255);
  }

  private syncSucursal(updated: Sucursal): void {
    this.sucursales = this.sucursales.map(s =>
      s.COD_SURC === updated.COD_SURC ? { ...s, ips: updated.ips } : s
    );
  }
}
